import { useSelector } from 'react-redux';
import { Image } from '@cian/ui-kit';
import React from 'react';

import { selectIsWebview } from '../../../selectors/selectIsWebview';
import { selectSubmitFormData } from '../../../selectors/selectSubmitFormData';
import {
  DEFAULT_TEXT_WITHOUT_CHAT,
  DEFAULT_TITLE_WITHOUT_CHAT,
  HELPER_TEXT_WITH_CREATED_CHAT,
  TITLE_WITH_CREATED_CHAT,
  TITLE_WITH_OPENED_CHAT,
} from '../constants';
import { DESKTOP_SUBMIT_FORM_URL } from '../../../constants/images';
import { CloseWebview } from '../../../components/QuizCompleteSuccess/components/CloseWebview';
import { BackButton, SuccessCircle } from '../../../components/QuizCompleteSuccess/components';
import { useFormTracking } from '../../../utils/useFormTracking';
import { IQuizCompletedProps } from '../../../components/QuizCompleteSuccess/QuizCompletedSuccess';
import { GoToChatButton } from '../../../components/QuizCompleteSuccess/components/GoToChatButton';
import { useApplicationContext } from '../../../utils/applicationContext';
import { IWebViewChatUrl } from '../types';
import { useWebViewRedirect } from '../../../utils/useWebViewRedirect';
import { TChatInfo } from '../../../slices';

interface IGetQuizCompletedSuccessProps extends IQuizCompletedProps {
  handleOpenChat: () => void;
}

//  TODO: переписать, полностью изолировав логику запроса chatId и перехода тут
export const useGetQuizCompletedSuccessProps = (
  isChatOpen: boolean,
  chatInfo?: TChatInfo,
): IGetQuizCompletedSuccessProps => {
  const { config } = useApplicationContext();
  const cianWebChatUrl = config.getStrict<string>('request-form-realtor-frontend.CianChatUrl') || '';
  const cianAppChatUrl = config.getStrict<IWebViewChatUrl>('request-form-realtor-frontend.CianAppChatUrl');
  const url = chatInfo?.chatId ? `${cianWebChatUrl}?chatId=${chatInfo.chatId}` : cianWebChatUrl;
  const webviewUrl = chatInfo?.chatId
    ? `${cianAppChatUrl.specificChatDialogueBaseUrl}${chatInfo.chatId}`
    : cianAppChatUrl.allChatDialoguesBaseUrl;
  const { redirect } = useWebViewRedirect();

  const { trackCompleteButton, trackGoToCianChat } = useFormTracking();
  const isWebview = useSelector(selectIsWebview);
  const submitFormData = useSelector(selectSubmitFormData);
  const sentMessageFromCian = submitFormData?.sentMessageFromCian;
  const defaultImage = <Image src={DESKTOP_SUBMIT_FORM_URL} />;

  const handleOpenChat = () => {
    if (isWebview) {
      redirect(webviewUrl);
    } else {
      window.location.href = url;
    }
  };

  const backButton = isWebview ? (
    <CloseWebview onClick={trackCompleteButton} />
  ) : (
    <BackButton onClick={trackCompleteButton} />
  );

  //  TODO: локоничнее будет выразить через if ... return { ... }
  let title;
  let subtitle;
  let img;
  let footer;
  switch (true) {
    case isWebview && sentMessageFromCian:
      title = TITLE_WITH_CREATED_CHAT;
      subtitle = null;
      img = <SuccessCircle />;
      footer = null;
      break;
    case sentMessageFromCian && isChatOpen:
      title = TITLE_WITH_OPENED_CHAT;
      subtitle = null;
      img = <SuccessCircle />;
      footer = <GoToChatButton onClick={trackGoToCianChat} href={url} />;
      break;
    case sentMessageFromCian && !isChatOpen:
      title = TITLE_WITH_CREATED_CHAT;
      subtitle = HELPER_TEXT_WITH_CREATED_CHAT;
      img = <SuccessCircle />;
      footer = null;
      break;
    default:
      title = DEFAULT_TITLE_WITHOUT_CHAT;
      subtitle = DEFAULT_TEXT_WITHOUT_CHAT;
      img = defaultImage;
      footer = backButton;
  }

  return {
    title,
    subtitle,
    footer,
    img,
    isChatOpen,
    handleOpenChat,
  };
};
